const RESET_STATE = 'episodesScreen/RESET_STATE';
const SET_EPISODE_LIST_STATUS = 'episodesScreen/SET_EPISODE_LIST_STATUS';
const SET_EPISODE_PENDING_DELETION =
  'episodesScreen/SET_EPISODE_PENDING_DELETION';

export default {
  RESET_STATE,
  SET_EPISODE_LIST_STATUS,
  SET_EPISODE_PENDING_DELETION,
};
